var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2071 4.29289C12.5976 4.68342 12.5976 5.31658 12.2071 5.70711L7.91421 10L12.2071 14.2929C12.5976 14.6834 12.5976 15.3166 12.2071 15.7071C11.8166 16.0976 11.1834 16.0976 10.7929 15.7071L6.14645 11.0607C5.56066 10.4749 5.56066 9.52513 6.14645 8.93934L10.7929 4.29289C11.1834 3.90237 11.8166 3.90237 12.2071 4.29289Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default ForwardRef;